export default __webpack_public_path__ + "static/media/preview-icon.8e4923d1.svg";